import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { getTypographyCss } from '@revenuemarket/design';

import { MenuItemProps } from './MenuList';

export const MenuList = styled.ul``;

export const MenuItem = styled.li`
  position: relative;
`;

export const Anchor = styled.a<Pick<MenuItemProps, 'active'>>`
  display: flex;
  align-items: center;
  position: relative;
  padding-left: 20px;
  min-height: 44px;
  cursor: pointer;

  border-radius: 0px 4px 4px 0px;
`;

export const ExpandIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 12px;
  right: 12px;
  width: 20px;
  height: 20px;
`;

export const SubMenuWrapper = styled.div<{ isExpand?: boolean }>`
  position: relative;
  max-height: 0;
  transition: max-height 0.15s ease-out;
  overflow: hidden;

  > ${Anchor} {
    padding-left: 50px;
  }

  ${({ isExpand }) =>
    isExpand &&
    css`
      max-height: 500px;
      transition: max-height 0.25s ease-in;
    `}
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 0 0 20px;
  margin-right: 10px;
  height: 20px;
  position: relative;
`;

export const Text = styled.div<Pick<MenuItemProps, 'active'>>`
  ${getTypographyCss('h4')};
  color: ${({ theme, active }) =>
    active ? theme.colors.grayscaleWhite : theme.colors.grayscale400};
`;
